import type { OptionsDocument } from 'paintscout'

export function mapPublicToTags({ options, tags }: { options: OptionsDocument; tags: string[] }): string[] {
  const res = tags?.map((tagId) => {
    const found = Object.entries(options?.options?.quoteTags?.values ?? {}).find(
      ([key, value]) => key === tagId || value.label === tagId
    )
    return found ? found[0] : ''
  })
  return res.filter(Boolean)
}
